<template>
  <b-button v-bind="$attrs" v-on="$listeners" :disabled="loading">
    <span v-if="loading" class="spinner-border mr-2 loading-spinner-1" role="status">
      <span class="sr-only loading-spinner-1"></span>
    </span>

    <slot />
  </b-button>
</template>

<script>

export default {
  name: 'LoadingButton',
  props: {
    loading: {
      type: Boolean,
      required: false
    }
  }
}
</script>

<style>

.loading-spinner-1 {
  width: 1.2em !important;
  height: 1.2em  !important;
}

</style>
